import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyVendor } from 'src/app/classes/models';
import { VendorReview } from 'src/app/classes/models/vendor-review';
import { AuthService } from 'src/app/services/auth.service';
import { CompanyVendorService } from 'src/app/services/company-vendor.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-add-edit-vendor-review-modal',
  templateUrl: './add-edit-vendor-review-modal.component.html',
  styleUrls: ['./add-edit-vendor-review-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AddEditVendorReviewModalComponent implements OnInit {
  constructor(
    public activeModal: NgbActiveModal,
    private CompanyVendorService: CompanyVendorService,
    private AuthService: AuthService,
    private ToastService: ToastService
  ) {}

  @Input() yourVendorRating?: VendorReview;
  @Input() CompanyVendor!: CompanyVendor;
  @Input() isNewVendorReview: boolean = false;

  close() {
    this.activeModal.dismiss('Cross Click');
  }

  addEditReview() {
    if (!this.yourVendorRating) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot add/edit VendorReview. No VendorReview found.',
        { returnError: true }
      );
    }

    this.CompanyVendorService.saveVendorReview(this.yourVendorRating).subscribe(
      {
        next: (vendorReview: VendorReview) => {
          Object.assign(this.yourVendorRating!, vendorReview);
          this.activeModal.close(this.yourVendorRating);
        }
      }
    );
  }

  closeModal(result?: any) {
    this.activeModal.close(result);
  }

  ngOnInit(): void {
    if (!this.yourVendorRating) {
      const { VendorId, ExemptVendorId, ClientRegisteredVendorId, CompanyId } =
        this.CompanyVendor;
      const UserId: number = this.AuthService.getUserId();
      const vendorReviewQuestions = {};

      this.isNewVendorReview = true;

      Array(10)
        .fill(0)
        .forEach((value, index) =>
          Object.assign(vendorReviewQuestions, {
            [`question${index + 1}Score`]: null
          })
        );

      this.yourVendorRating = new VendorReview({
        CompanyId,
        UserId,
        ...vendorReviewQuestions
      });

      if (this.CompanyVendor.VendorId) {
        Object.assign(this.yourVendorRating, { VendorId });
      }

      if (this.CompanyVendor.ExemptVendorId) {
        Object.assign(this.yourVendorRating, { ExemptVendorId });
      }

      if (this.CompanyVendor.ClientRegisteredVendorId) {
        Object.assign(this.yourVendorRating, { ClientRegisteredVendorId });
      }
    }
  }
}
